import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftraggeber, IRolle } from "../types/Types";

/**
 * @author mb
 */
export const FakturaAPI = createApi({
    reducerPath: "fakturaAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "faktura",
            credentials: 'include'
        }),
    tagTypes: ['fakturaAPI'], // for caching
    endpoints: (builder) => ({
        getDl: builder.mutation<any[], void>(
            {
                query: () => ({
                    url: 'getDl',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getRechnungsanlage: builder.mutation<{ blob: Blob; filename: string }, any>(
            {
                query: (dto) => ({
                    url: 'getRechnungsanlage',
                    method: 'post',
                    credentials: 'include',
                    body: dto,
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        const disposition = response.headers.get('Content-Disposition');
                        const filename = disposition?.match(/filename="?(.+?)"?/)?.[1] ?? 'rechnungsanlage.zip';
                        return { blob, filename };
                    },
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
            }
        ),
    })
});

export const {

    useGetDlMutation,
    useGetRechnungsanlageMutation,

} = FakturaAPI;
